export default __webpack_public_path__ + "static/image2-c653feec2f1fc94813cfc40b1c8f5e30.gif";